module.exports = new __parcel__URL__("thumbnail.f5c51c46.png").toString();